
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { handleError } from '../../../../api';
import { Card, TaskItem } from '../../../backend/backendapi';
import { KanbanState } from '../../kanban.model';
import TaskItemModal from '../TaskItemModal';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    Task: require('../task/task.vue.html').default,
    TaskItemModal,
  },
})
export default class Tasks extends Vue {
  @Prop({ required: true })
  state!: KanbanState;
  @Prop({ required: true })
  card!: Card;
  @Prop({ default: false })
  readonly!: boolean;
  @Prop({ default: false })
  lockeddown!: boolean;

  newTaskItem: string | null = null;

  get taskProgress(): number {
    if (!this.card.taskItems?.length)
      return 0;
    return this.card.taskItems.filter(e => e.status === 'DONE').length / this.card.taskItems.length * 100;
  }

  taskCreate(): void {
    if (this.readonly) {
      return;
    }

    if (!this.newTaskItem || !this.newTaskItem.trim())
      return;

    let task = new TaskItem();
    task.cardId = this.card.id;
    task.createdOn = new Date();
    task.completedOn = undefined;
    task.name = this.newTaskItem!;
    task.status = 'UNDONE';

    //save to backend
    this.state.taskAPI.create(task)
        .then(newtask => {
          this.$toasted.info(this.$t('txtSaved').toString());

          if (!this.card.taskItems)
            this.card.taskItems = [];
          this.card.taskItems.push(newtask.result!);
          this.card.updatedOnForReadConfirmation = new Date();
        })
        .catch(e => handleError(this.$toasted, this.$i18n, e));

    this.newTaskItem = null;
  }

  taskToggle(task: TaskItem, checked: boolean): void {
    if (this.readonly) {
      return;
    }

    let tmp = task.clone();
    tmp.status = checked ? 'DONE' : 'UNDONE';
    tmp.completedOn = checked ? new Date() : undefined;

    //save to backend
    this.state.taskAPI.update(tmp)
        .then(_ => {
          this.$toasted.info(this.$t('txtSaved').toString());
          task.status = checked ? 'DONE' : 'UNDONE';
          task.completedOn = checked ? new Date() : undefined;
        })
        .catch(e => handleError(this.$toasted, this.$i18n, e)); //TODO reset check box on failure
  }

  taskEdit(task: TaskItem): void {
    if (this.readonly) {
      return;
    }

    (this.$refs.taskItemModal as TaskItemModal).open(this.card, task);
  }

  taskDelete(task: TaskItem): void {
    if (this.readonly) {
      return;
    }

    const card = this.card;
    const index = (card.taskItems ?? []).findIndex(e => e.id === task.id);
    if (index > -1) {
      //save to backend
      this.state.taskAPI.delete(task.id!)
          .then(_ => {
            this.$toasted.info(this.$t('txtDeleted').toString());
            card.taskItems?.splice(index, 1);
            card.updatedOnForReadConfirmation = new Date();
          })
          .catch(e => handleError(this.$toasted, this.$i18n, e));
    }
  }
}

